



























import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { VFields } from '@/models/v-fields';
import {  TechClassSetup } from '@/models/admin/store';
import { Base } from '@/components/common/base';
import { storeService } from '@/shared';
import { Utils } from '@/helper/utils';

@Component({
  props: ['methodName', 'progress'],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
})
export default class SavePositivePaySetup extends Base {
    public techClassSetupFields: Array<VFields<any>>  = [
      {
        key: 'techClass',
        required: true,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          label: 'Tech Class',
          loading: false,
          rules:[
            v => this.required('Tech Class', v)
          ]
        },
      },      
      ];


  public techClassModel: TechClassSetup = {
  id:"",
  techClass: '',
  };

  public techClassModelId :string = "";
  public storeId: number = 0;
  public form: any = {};
  public requestProgress: boolean = false;
  
  public callMethod(methodName): void {
    if (methodName === 'backToStoreEdit') {
      this.$router
        .push({
          name: 'admin.stores.edit',
          params: { id: this.storeId.toString(), tab: 'TechClassSetup' },
        })
        .catch((ex) => {
          console.log(ex);
        });
    }
    if (methodName === 'submit') {
      if (!this.form.$valid) {
        this.showAlert(false, 'Form is Invalid!');
        this.resetMethodName(methodName);
        return;
      }
      this.saveTechClassSetupDetails();
    }
    this.resetMethodName(methodName);
  }
  public resetMethodName(methodName): void {
    if (methodName !== '') {
      this.$emit('resetMethodName', methodName);
    }
  }
  public updateToolBar(): void {
    const buttons: any = [];
    if (this.storeId) {
      buttons.push({
        id: '0',
        type: 'button',
        title: this.$parent.$t('stores.btnBackToStoreTitle'),
        disabled: false,
        visible: true,
        class: 'btn',
        label: this.$parent.$t('stores.btnBack'),
        click: 'backToStoreEdit',
        icon: 'fas fa-arrow-left',
      });
    }
    this.$emit('updateToolBar', buttons);
  }

  public mounted() {
    this.storeId = Number(this.$route.params.storeId);
    if (this.$route.params.id) {
      this.techClassModelId = this.$route.params.id;
      this.getStoreInfo();
    }
   
    this.updateToolBar();
    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });
  }

  public async getStoreInfo(): Promise<void> {
    try {
      this.formlyShowSkeleton(this.techClassSetupFields);
      const response = await storeService.getStore(this.storeId);
      const techClassSetup = response.storeJson.techClassSetups.find(
        (m) => m.id == this.techClassModelId
      );

      if(this.techClassModelId){
        this.techClassModel.id = techClassSetup.id;
        this.techClassModel.techClass = techClassSetup.techClass;
      }
     
    } finally {
      this.formlyHideSkeleton(this.techClassSetupFields);
    }
  }

  public validateTrunkDetails(): Vue & { validate: () => boolean } {
    return this.$refs.TechClassSetupForm as Vue & { validate: () => boolean };
  }

  public async saveTechClassSetupDetails(): Promise<void> {
    if(this.validateTrunkDetails().validate()){
      try {
        this.requestProgress = true;
        this.$emit('update:progress', this.requestProgress);
        if (this.techClassModel.id === '') {
          await storeService.saveTechClassSetupDetails(this.storeId,this.techClassModel.techClass);
          this.showAlert(true, 'Tech Class Added successfully');
          this.$router
            .push({
              name: 'admin.stores.edit',
              params:{
                tab:'TechClassSetup'
              }
            })
            .catch((ex) => {
              console.log(ex);
            });
        } else {

          await storeService.updateTechClassSetupDetails(this.techClassModel.id,this.storeId,this.techClassModel.techClass);
          this.showAlert(true, 'Tech Class Updated successfully');
          this.$router
            .push({
              name: 'admin.stores.edit',
              params:{
                tab:'TechClassSetup'
              }
            })
            .catch((ex) => {
              console.log(ex);
            });
        }
      } finally {
        this.requestProgress = false;
        this.$emit('update:progress', this.requestProgress);
      }
    }
  }
}
